<template>
    <div class="send-invitation-content card-box-style rounded rounded-30">
        <h3>Send Invitation</h3>
        <form @submit.prevent class="invitation-form">
            <div class="form-group">
                <input type="text" class="form-control" placeholder="Enter email address">
                <button type="submit" class="invitation-btn">Send Invitation</button>
            </div>
        </form>

        <h4>Quick Send Email</h4>
        <p>Lorem ipsum dolor sit amet, consete tur sadipscing elitr, sed diam.</p>

        <div class="invitation-content d-flex justify-content-between align-items-center">
            <ul class="group-img">
                <li>
                    <a href="#">
                        <img src="../../../assets/images/group/group-1.png" alt="group-1">
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="../../../assets/images/group/group-2.png" alt="group-2">
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="../../../assets/images/group/group-3.png" alt="group-3">
                    </a>
                </li>
                <li>
                    <a href="#">
                        <img src="../../../assets/images/group/group-4.png" alt="group-4">
                    </a>
                </li>
                <li>
                    <a href="#" class="total-man">
                        <img src="../../../assets/images/group/group-5.png" alt="group-5">
                        <span>32+</span>
                    </a>
                </li>
            </ul>

            <a href="#" class="view-all">
                View All
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SendInvitation'
}
</script>

<style lang="scss">
.send-invitation-content {
	h3 {
		font-size: 16px;
		font-weight: 600;
		padding-bottom: 20px;
		margin-bottom: 20px;
		border-bottom: 2px solid #F8FAFF;
	}
	.invitation-form {
		padding-bottom: 20px;
		margin-bottom: 20px;
		border-bottom: 1px solid #F8FAFF;
		.form-group {
			.form-control {
				background: #F1F5FF 0% 0% no-repeat padding-box;
				border-radius: 40px;
				margin-bottom: 20px;
				height: 43px;
				&:focus {
					border-color: #5C31D6;
				}
			}
			.invitation-btn {
				width: 100%;
				background-color: #5C31D6;
				border-radius: 40px;
				color: var(--white-color);
				padding: 10px 30px;
			}
		}
	}
	h4 {
		color: #67748E;
		font-size: 14px;
		font-weight: 500;
	}
	p {
		font-size: 14px;
		color: #9DA3B1;
		margin-bottom: 20px;
	}
	.invitation-content {
		.group-img {
			padding: 0;
			margin-bottom: 0;
			list-style-type: none;
			li {
				display: inline-block;
				margin-right: -20px;
				a {
					position: relative;
					img {
						border-radius: 50px;
					}
					&.total-man {
						span {
							position: absolute;
							top: 3px;
							right: 0;
							left: 0;
							font-size: 11px;
							font-weight: 500;
							text-align: center;
							display: block;
							color: var(--white-color);
							z-index: 1;
							&::before {
								content: "";
								position: absolute;
								top: -11px;
								left: 1px;
								width: 40px;
								height: 40px;
								border-radius: 50px;
								background-color: rgba(0, 0, 0, 0.5);
								z-index: -1;
							}
						}
					}
				}
			}
		}
		.view-all {
			border-radius: 10px;
			color: #67748E;
			border: 1px solid #BCC2CF;
			font-size: 14px;
			padding: 10px 15px;
			transition: var(--transition);
			&:hover {
				background-color: #5C31D6;
				color: var(--white-color);
			}
		}
	}
	
}
</style>